import Dispatcher from '../dispatcher';
import resolvePromise from '../helper/resolved_promise';
import { actions } from '../constants/fitting_station_finder/actions';
import { fetchStations } from './fitting_station_actions/fetch_stations';
import { hideAction as unlockUi } from '../actions/ui_lock_actions';

class StationsActions {
    static clearStationAction() {
        Dispatcher.handleStationsAction({
            type: actions.CLEAR_STATION,
        });
        return resolvePromise();
    }

    static setQuantityAction() {
        Dispatcher.handleStationsAction({
            type: actions.SET_QUANTITY,
        });
        return resolvePromise();
    }

    static showDetailsAction(payload) {
        Dispatcher.handleStationsAction({
            type: actions.SHOW_DETAILS,
            payload,
        });

        return resolvePromise();
    }

    static showListAction() {
        Dispatcher.handleStationsAction({
            type: actions.SHOW_LIST,
        });

        return resolvePromise();
    }

    static showAllCostsAction(stationId) {
        Dispatcher.handleStationsAction({
            type: actions.SHOW_ALL_COSTS,
            payload: stationId
        });

        return resolvePromise();
    }

    static hideAllCostsAction(stationId) {
        Dispatcher.handleStationsAction({
            type: actions.HIDE_ALL_COSTS,
            payload: stationId
        });

        return resolvePromise();
    }

    static showChangePostcodeForm() {
        const type = actions.SHOW_CHANGE_POSTCODE_FORM;
        Dispatcher.handleStationsAction({ type });
        return resolvePromise();
    }

    static hideChangePostcodeForm() {
        const type = actions.HIDE_CHANGE_POSTCODE_FORM;
        Dispatcher.handleStationsAction({ type });
        return resolvePromise();
    }

    static startFetchingStationsAction() {
        Dispatcher.handleStationsAction({ type: actions.FETCH_STATIONS });
    }

    static fetchStationsAction(payload, products) {
        StationsActions.abortOngoingRequests();

        if (products.length === 1) {
            const payloadWithProduct = {
                ...payload,
                qty: products[0].qty,
                id: products[0].id,
                supplierKey:products[0].supplierKey,
            };
            const fetchWithoutPrices = fetchStations('fetchWithoutPrices', payloadWithProduct, true, false);
            if (!fetchWithoutPrices) {
                unlockUi();
                return;
            }
            const fetchWithPrices = fetchStations('fetchWithPrices', payloadWithProduct, false, false);

            this.handleFetchRequest(
                fetchWithoutPrices,
                'fetchWithoutPrices',
                false
            );

            return this.handleFetchRequest(
                $.when(fetchWithoutPrices, fetchWithPrices),
                'fetchWithPrices',
                true
            );
        } else if (products.length > 1) {
            const payloadWithProduct = {
                ...payload,
                qty: products[0].qty,
                id: products[0].id,
                supplierKey:products[0].supplierKey,
            };

            const fetchWithoutPrices = fetchStations('fetchWithoutPrices', payloadWithProduct, true, true);

            if (!fetchWithoutPrices) {
                unlockUi();
                return;
            }
            this.handleFetchRequest(
                fetchWithoutPrices,
                'fetchWithoutPrices',
                false
            );
        }

        return this.handleFetchRequest(
            fetchStations('fetchWithPrices', payload, false, products.length > 1),
            'fetchWithPrices',
            true
        );
    }

    static handleFetchRequest(request, requestType, pricesLoaded) {
        return request
            .then(this.handleFetchedStations.bind(this, pricesLoaded))
            .catch(this.handleFailedStations)
            .done(StationsActions.clearRequest.bind(requestType));
    }

    static handleFetchedStations(pricesLoaded, p1, p2) {
        const stations = p2 || p1;

        if (!(stations instanceof Array)) {
            return $.Deferred().reject().promise();
        }
        Dispatcher.handleStationsAction({
            type: actions.STATIONS_FETCHED,
            payload: {
                stations,
                pricesLoaded,
            },
        });
    }

    static handleFailedStations(jqXHR, err) {
        Dispatcher.handleStationsAction({
            type: actions.FETCHING_STATIONS_FAILED,
            payload: err,
        });
    }

    static sortStationsAction(payload) {
        Dispatcher.handleStationsAction({
            type: actions.SORT_STATIONS,
            payload,
        });

        return resolvePromise();
    }

    static abortOngoingRequests() {
        if (StationsActions.fetchWithoutPrices) {
            StationsActions.fetchWithoutPrices.abort();
            StationsActions.fetchWithoutPrices = null;
        }

        if (StationsActions.fetchWithPrices) {
            StationsActions.fetchWithPrices.abort();
            StationsActions.fetchWithPrices = null;
        }
    }

    static clearRequest(request) {
        StationsActions[request] = null;
    }
}

StationsActions.fetchWithoutPrices = null;
StationsActions.fetchWithPrices = null;
StationsActions.removeStation = null;

export default StationsActions;
